// extracted by css-extract-rspack-plugin
export default {"avatar":"MGMbe0","avatarImage":"ZCbMiK","avatarFallback":"losIqj"};